import React, { useEffect, useState } from "react";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { Link, NavLink, useNavigate } from "react-router-dom";
import TierPlanDetails from "../../Components/TierPlanDetails/TierPlanDetails";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import { PlanDetailsApi } from "../../Utils/Api/PlanDetailsApi";
import { useSelector } from "react-redux";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader/Loader";

const MyProfileSubscriptionPlanDetails = ({ flag }) => {
  const [currentTab, setcurrentTab] = useState("");
  const [planDetails, setPlanDetails] = useState({});
  const [loading, setLoading] = useState(false);

  const path = window.location.href;
  const endPath = path.split("/");

  useEffect(() => {
    if (endPath[4] === "subscription") {
      setcurrentTab("subscription");
    }
  }, []);

  const navigate = useNavigate();

  // persisted Redux
  const data = useSelector((state) => state.PersistedData);

  const PlanId = data.MyProfileSubscription.MySubscriptionPlanId;

  const PlanDetails = async () => {
    const data = {
      plan_id: PlanId,
    };

    setLoading(true);
    const PlanDetailsRes = await PlanDetailsApi(data, () => {
      navigate("/");
    });

    if (PlanDetailsRes === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (PlanDetailsRes.success === true) {
        setPlanDetails(PlanDetailsRes.data[0]);
        setLoading(false);
      }else if (PlanDetailsRes.status === 429) {
        setLoading(true);
        toast.error(PlanDetailsRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }  else {
        setPlanDetails({});
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    PlanDetails();
  }, []);

  return (
    <div className="gray-bg">
      {loading === true ? <Loader /> : ""}
      <div className="navbar-section p-0">
        <Navigation />
      </div>
      <div className="main-content pt-5 pr-3 pb-4">
        <p className="page-text dashboard">
          <Link to={"/my-profile/subscription"}>
            <MdKeyboardArrowLeft className="arrow-left" />
            Back
          </Link>
        </p>
        <p className="page-maintitle">My Profile</p>
        {/* {CheckChargebeeSubscriptionFlag && (
          <p className="app_locked_info_text">
            (Your account has been suspended as the grace period has ended.
            Please renew your plan to reactivate your account.)
          </p>
        )} */}
        <div className="acc-dashboard mt-4">
          <div className="mb-2 tabs_ul">
            <NavLink to={"/my-profile/general-info"} className={"tabs_li"}>
              General Info
            </NavLink>
            <NavLink to={"/my-profile/business-info"} className={"tabs_li"}>
              Business Info
            </NavLink>
            <NavLink to={"/my-profile/store-info"} className={"tabs_li"}>
              Store Info
            </NavLink>
            <NavLink
              className={
                currentTab === "subscription" ? " activeTab" : "tabs_li"
              }
            >
              Subscription
            </NavLink>
            {/* <NavLink to={"/my-profile/bank-info"} className={"tabs_li"}>
                Bank Info
              </NavLink> */}
            {/* <NavLink
              to={"/my-profile/transaction-history"}
              className={"tabs_li"}
            >
              Transaction History
            </NavLink> */}
            <NavLink
              to={"/my-profile/marketplace-membership"}
              className={"tabs_li"}
            >
              Marketplace Membership
            </NavLink>
          </div>
          <TierPlanDetails
            title={
              planDetails?.subscription_name
                ? planDetails?.subscription_name + " " + "Plan "
                : ""
            }
            PlanId={PlanId}
            aboutDetails={
              planDetails?.subscription_desc
                ? planDetails?.subscription_desc
                : "No Data Available!"
            }
            features={{
              key1: planDetails?.subscription_marketplace_count
                ? planDetails?.subscription_marketplace_count + " Marketplaces"
                : "",
              key2: planDetails?.subscription_voucher_count
                ? planDetails?.subscription_voucher_count + " Voucher"
                : "",
              key3: planDetails?.subscription_coupon_count
                ? planDetails?.subscription_coupon_count + " Coupon"
                : "",
            }}
            TandC={
              planDetails?.subscription_tnc
                ? planDetails?.subscription_tnc
                : "No Data Available!"
            }
            cancel="/my-profile/subscription"
          />
          <div className="mt-3"></div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </div>
  );
};

export default MyProfileSubscriptionPlanDetails;
